import React, { useEffect } from "react";
import {
  useTheme,
  IconButton,
  Typography,
  Toolbar,
  AppBar,
  ListItem,
  List,
  SwipeableDrawer,
  Box,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import NavLink from "../components/customcomponents/NavLink";
import LogOutDialog from "../components/LogOutDialog";
import logoutImage from "../assets/images/logout.svg";
import { getDashboardStyle } from "../components/customstyles/DashboardStyle";
import { AuthContext } from "../context/AuthContext";
import { useLocation } from "react-router-dom";
const useStyles = () => {
  const theme = useTheme();
  return getDashboardStyle(theme);
};

const ELEVATION_THRESHOLD = 2;
const PUBLIC_ROUTES = ["/login", "/logout"];

const LogoutButton = ({ setShowLogoutDialog, variant = "small" }) => {
  const styles = useStyles();
  const shouldTextWrap = useMediaQuery("(max-width: 1200px)");
  return (
    <Box
      onClick={() => {
        setShowLogoutDialog(true);
      }}
      sx={{
        ...styles.navbarLogoutStyle,
        padding: shouldTextWrap ? "0px" : "20px 10px",
      }}
    >
      <img
        src={logoutImage}
        style={{
          marginRight: "6px",
        }}
        alt="logout"
      />
      Log{variant === "big" && shouldTextWrap ? <br /> : " "}Out
    </Box>
  );
};

function Navbar() {
  const styles = useStyles();
  const isSmallScreen = useMediaQuery("(max-width:810px)");
  const shouldShrink = useMediaQuery("(max-width:1040px)");
  const location = useLocation();
  const { isAuthenticated, logout } = React.useContext(AuthContext);
  const showNavLinks = React.useMemo(
    () =>
      (isAuthenticated && !PUBLIC_ROUTES.includes(location.pathname)) ||
      location.pathname === "/privacypolicy",
    [location, isAuthenticated]
  );
  const [showLogoutDialog, setShowLogoutDialog] = React.useState(false);
  const [state, setState] = React.useState({
    left: false,
  });
  const [scroll, setScroll] = React.useState(window.scrollY);
  const homeLink = "/patients";

  const toggleDrawer = (side, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ state, [side]: open });
  };

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const sideList = (side) => (
    <Box
      sx={styles.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
    >
      <List>
        <ListItem>
          <Box
            sx={styles.dispBlk}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div style={{ marginLeft: "10px" }}></div>
            <div style={{ marginRight: "65px" }}>
              <LogoutButton setShowLogoutDialog={setShowLogoutDialog} />
            </div>
          </Box>
        </ListItem>
      </List>
    </Box>
  );
  const checkCursor = (showNavLinks) => {
    if (location.pathname === "/privacypolicy") {
      return "none";
    } else {
      return showNavLinks ? "initial" : "none";
    }
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={scroll > ELEVATION_THRESHOLD ? 2 : 0}
        sx={styles.appBar}
      >
        <Toolbar
          style={{
            padding: 0,
            width: "100%",
            maxWidth: "1600px",
            margin: "0 auto",
          }}
        >
          {/*big screen*/}
          <Typography
            sx={{ display: isSmallScreen ? "none" : "block" }}
            variant="h6"
            color="inherit"
          >
            <NavLink
              sx={{
                padding: shouldShrink ? "8px 5px" : "8px 20px",
                pointerEvents: checkCursor(showNavLinks),
              }}
              to={homeLink}
              activeStyle={{
                borderBottom: "none",
              }}
            >
              <Typography
                sx={{
                  width: "250px",
                  textColor: "#263238",
                  fontSize: "20px",
                  fontWeight: "600px",
                }}
              >
                AIMS Assessment
              </Typography>
            </NavLink>
          </Typography>
          {showNavLinks && (
            <IconButton
              sx={{
                ...styles.menuButton,
                display: isSmallScreen ? "block" : "none",
              }}
              color="inherit"
              aria-label="Menu"
              onClick={toggleDrawer("left", true)}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Typography
            variant="h6"
            color="inherit"
            sx={{
              display: isSmallScreen ? "block" : "none",
              marginLeft: "10px",
            }}
          >
            <NavLink
              to={homeLink}
              sx={{
                padding: "8px 0px",
                pointerEvents: checkCursor(showNavLinks),
              }}
              activeStyle={{
                borderBottom: "none",
              }}
            >
              <Typography
                sx={{
                  textColor: "#263238",
                  fontSize: "20px",
                  fontWeight: "600px",
                }}
              >
                AIMS Assessment
              </Typography>
              {/* <img src={eyleaHDLogo} height="37px" alt="eylea HD logo" />
              <img src={eyleaLogo} height="40px" alt="eylea logo" /> */}
            </NavLink>
          </Typography>
          {/*big screen*/}
          {showNavLinks && (
            <Box
              sx={{
                width: "100%",
                textDecoration: "none",
                display: isSmallScreen ? "none" : "flex",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ minWidth: "184px" }}></Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box
                  sx={{
                    display: isSmallScreen ? "none" : "block",
                  }}
                ></Box>
                <LogoutButton
                  setShowLogoutDialog={setShowLogoutDialog}
                  variant="big"
                />
              </Box>
            </Box>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar style={{ marginTop: "10px" }} />
      <SwipeableDrawer
        sx={{ width: "100%" }}
        open={state.left}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
      >
        {sideList("left")}
      </SwipeableDrawer>

      {showLogoutDialog && (
        <LogOutDialog
          logout={logout}
          setShowLogoutDialog={setShowLogoutDialog}
        />
      )}
    </>
  );
}

export default Navbar;
